/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import { useState } from 'react';

export interface ISignUpCheckbox {
    id?: string;
    name: string;
    text?: any;
    className?: string;
    onChange?: undefined;
    ariaLabel?: string;
    isCheckedValue?: boolean;
}

export const SignUpKeepUpCheckbox: React.FC<ISignUpCheckbox> = ({ id, className, text, name, onChange, isCheckedValue }) => {
    const initialChecked = !!isCheckedValue;
    const [textValue, setValue] = useState<string>(initialChecked ? 'true' : 'false');
    const [isChecked, setIsChecked] = useState<boolean>(!!isCheckedValue);

    const _change = (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            const checked = e.target.checked;
            setIsChecked(checked);
            setValue(checked ? 'true' : 'false');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error in SignUpKeepUpCheckbox:', error);
        }
    };
    return (
        <div style={{ display: 'table' }} className='checkbox-container'>
            <label>
                <input
                    type='checkbox'
                    id={id}
                    value={textValue}
                    name={name}
                    onChange={_change}
                    style={{ display: 'table-cell', verticalAlign: 'bottom' }}
                    checked={isChecked}
                />
                <span className={`checkmark ${isChecked ? 'checked' : ''}`}></span>
                {text && <div style={{ display: 'table-cell' }} dangerouslySetInnerHTML={{ __html: text }} />}
            </label>
        </div>
    );
};

export const SignUpTermsAndConditionsCheckbox: React.FC<ISignUpCheckbox> = ({ id, className, text, name, ariaLabel }) => {
    const [textValue, setValue] = useState('');
    const _change = () => {
        const updatedValue: any = textValue === 'true' ? '' : 'true';
        const isChecked = updatedValue === 'true';
        const e: any = document.getElementById('continue');
        if (e) {
            e.disabled = !isChecked;
        }
        setValue(updatedValue);
    };
    return (
        <div style={{ display: 'table' }} className='checkbox-container'>
            <label>
                <input
                    type='checkbox'
                    id={id}
                    value={textValue}
                    name={name}
                    aria-label={ariaLabel}
                    onChange={_change}
                    style={{ display: 'table-cell', verticalAlign: 'bottom' }}
                />
                <span className='checkmark'></span>
                {text && <div style={{ display: 'table-cell' }} dangerouslySetInnerHTML={{ __html: text }} />}
            </label>
        </div>
    );
};
